import { analytics } from '@/common/analytics/analytics'
import { ANALYTICS_EVENTS } from '@/common/analytics/events'
import { BundleT } from '@/common/types'
import { Alert } from '@/common/ui/alert'
import { H2 } from '@/common/ui/h2'
import { InfoIconTooltip } from '@/common/ui/tooltip'
import { BUNDLE_COPY } from '@/locales/en'
import { Clock9Icon } from 'lucide-react'

type Props = {
    bundle: BundleT
}

export const BundlePastReturns: React.FC<Props> = ({ bundle }) => {
    const lastUpdated = bundle?.performance?.lastUpdated
        ? new Date(bundle.performance?.lastUpdated).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
          })
        : undefined

    const onTooltipOpen = (open?: boolean) => {
        if (open) {
            analytics.track(ANALYTICS_EVENTS.TRADING.BUNDLE_TOOLTIP_OPENED, {
                bundle_id: bundle.slug,
                tooltip: 'performanceInfo',
            })
        }
    }

    return (
        <div className="self-stretch flex flex-col justify-start items-start gap-6">
            <div className="self-stretch inline-flex flex-col justify-start items-start gap-1">
                <H2 className="text-center justify-start text-black text-3xl  md:text-3xl font-normal font-['Serious Sans'] leading-10 mb-0">
                    {BUNDLE_COPY.performance}
                </H2>
                <div>
                    <Clock9Icon className="inline mr-2 h-4 w-4 text-content-secondary" />
                    <span className="text-content-secondary text-xs font-normal font-['Inter'] leading-5">
                        {BUNDLE_COPY.lastUpdate.replace('{date}', lastUpdated || '')}
                    </span>
                </div>
            </div>
            <div className="self-stretch justify-start gap-4 flex flex-col items-start">
                <Alert variant={'default'} className="w-full p-6">
                    <ul className="w-full flex items-center divide-x divide-border-divider">
                        <li className="flex-1 flex flex-col items-start gap-1 pr-4">
                            <div className="text-sentiment-good text-base font-medium font-['Inter'] leading-6">
                                {bundle?.performance?.year1 || 'N/A'}
                            </div>
                            <div className="text-content-tertiary text-sm font-normal font-['Inter'] leading-5">
                                {BUNDLE_COPY.year1}
                            </div>
                        </li>
                        <li className="flex-1 flex flex-col items-start gap-1 px-4">
                            <div className="text-sentiment-good text-base font-medium font-['Inter'] leading-6">
                                {bundle?.performance?.year3 || 'N/A'}
                                <span className="text-content-tertiary text-sm font-normal font-['Inter'] leading-5">
                                    {BUNDLE_COPY.yearsSuffix}
                                </span>
                            </div>
                            <div className="text-content-tertiary text-sm font-normal font-['Inter'] leading-5">
                                {BUNDLE_COPY.year3}
                            </div>
                        </li>
                        <li className="flex-1 flex flex-col items-start gap-1 pl-4">
                            <div className="text-sentiment-good text-base font-medium font-['Inter'] leading-6">
                                {bundle?.performance?.year5 || 'N/A'}
                                <span className="text-content-tertiary text-sm font-normal font-['Inter'] leading-5">
                                    {BUNDLE_COPY.yearsSuffix}
                                </span>
                            </div>
                            <div className="text-content-tertiary text-sm font-normal font-['Inter'] leading-5">
                                {BUNDLE_COPY.year5}
                            </div>
                        </li>
                    </ul>
                </Alert>
                <div className="self-stretch flex flex-inline justify-start text-content-tertiary">
                    <div className="justify-center text-xs font-medium font-['Inter'] leading-5 pr-1">
                        {BUNDLE_COPY.performanceDisclaimer}
                    </div>
                    <InfoIconTooltip onOpenChange={onTooltipOpen}>
                        <div className="self-stretch justify-start text-content-primary text-sm font-medium font-['Inter'] leading-5">
                            {BUNDLE_COPY.performanceInfoTooltip}
                        </div>
                    </InfoIconTooltip>
                </div>
                {bundle?.performance?.additionalDisclaimer && (
                    <div className="justify-center text-xs text-content-tertiary font-medium font-['Inter'] leading-5 pr-1">
                        {bundle.performance.additionalDisclaimer}
                    </div>
                )}
            </div>
        </div>
    )
}
